
export const commonRegex = {
    onlyText: /^[a-zA-Z\s]*$/,
};
